require('../fhApp/appMetaService');
require('../pricing/plans/plansService');
require('../shared/leaguesService');
require('../fhApp/currentUser/currentUser');
require('../mainFrame/collapsableMenu/collapsableMenuService');

"use strict";

angular.module('app.welcome.welcomeController', [
  'app.appMetaService',
  'app.pricing.plans.plansService',
  'app.shared.leaguesService',
  'app.mainFrame.collapsableMenu.collapsableMenuService'
])
  .controller('app.welcome.welcomeController', [
    '$scope',
    'appMetaService',
    'app.pricing.plans.plansService',
    'app.shared.leaguesService',
    'currentUser',
    '$state',
    '$stateParams',
    'app.mainFrame.collapsableMenu.collapsableMenuService',
    'hostnameMatchService',
    function ($scope, appMeta, plans, leaguesService, currentUser, $state, $stateParams, collapsableMenu, hostnameMatchService) {
      $scope.appMeta = appMeta;
      $scope.activeSliderIndex = 0;
      $scope.sliderSpeed = 3000;
      $scope.plan = null;
      $scope.plans = null;
      $scope.leagues = null;
      $scope.currentLeagueIndex = 0;
      $scope.currentLeague = null;
      $scope.loadingTeams = false;
      $scope.error = null;
      $scope.login_name = $stateParams.login_name;
      $scope.password = null;
      $scope.show2021Freeview = false;

      let init = () => {
        /*let promise = plans.retrieve({plans: ['30dp', '365dp']});
        if (promise) {
          promise.then(
            function () {
              if (Array.isArray(plans.list) && plans.list.length) {
                $scope.plans = plans.list;
                if (Array.isArray(plans.list)) {
                  if (typeof plans.list[0] !== 'undefined') {
                    $scope.plan = plans.list[0];
                  }
                  plans.list.forEach((plan) => {
                    if (plan.level === Math.max($scope.plan.level, plan.level)) {
                      $scope.plan = plan;
                    }
                  });
                }
              }
            }
          );
        }*/

        leaguesService.getList(window.location.platform(undefined, hostnameMatchService.hostname()), 'teams', 'logos').then(
          function (response) {
            let shuffle = a => {
              for (let i = a.length - 1; i > 0; i--) {
                const j = Math.floor(Math.random() * (i + 1));
                [a[i], a[j]] = [a[j], a[i]];
              }
              return a;
            };
            $scope.leagues = response.data;//shuffle(response.data);
          }
        );

        if ($stateParams.autoLogin === true) {
          if ($stateParams.login_name && $stateParams.password) {
            $scope.password = $stateParams.password;
            $scope.login();
          }
        }
      };

      $scope.login = function () {
        currentUser.loginClicked = true;

        let callback = function () {
          collapsableMenu.buildItems();
          $state.go('app.home');
        };

        currentUser.login($scope.login_name, $scope.password)
          .then(callback)
          .catch(result => {
            $scope.error = {
              message: result.error,
              type: result.errorType
            }
          });
      };

      /*$scope.resendRegistrationEmail = () => {
        if ($scope.login_name && $scope.password) {
          currentUser.sendRegistrationEmail($scope.login_name, $scope.password)
            .then(response => {
              let data = response.data;
              if (data) {
                if (data.message) {
                  alert(data.message);
                }
              }
            })
            .catch(response => {
              let data = response.data;
              if (data) {
                if (data.error) {
                  alert(data.error);
                }
              }
            });
        } else {
          alert('Please provide your email address and password');
        }
      };

      let fetchTeams = function (league_index) {
        if (Array.isArray($scope.leagues) && $scope.leagues[league_index]) {
          if (!$scope.leagues[league_index].teams) {
            $scope.loadingTeams = true;
            return leaguesService.getLeague($scope.leagues[league_index].ileagueid).then(
              function (response) {
                $scope.leagues[league_index] = response.data;
                $scope.loadingTeams = false;
              }
            );
          }
        }
        return false;
      };

      let setCurrentLeague = function () {
        if ($scope.leagues) {
          $scope.currentLeague = $scope.leagues[$scope.currentLeagueIndex];
          let promise = fetchTeams($scope.currentLeagueIndex);
          if (promise) {
            promise.then(
              function () {
                $scope.currentLeague = $scope.leagues[$scope.currentLeagueIndex];
              }
            )
          }
        }
      };

      $scope.nextLeague = function () {
        if (Array.isArray($scope.leagues)) {
          let next_league_index = $scope.currentLeagueIndex + 1;
          if (next_league_index >= $scope.leagues.length) {
            next_league_index = 0;
          }
          $scope.currentLeagueIndex = next_league_index;
          setCurrentLeague();
        }
      };

      $scope.previousLeague = function () {
        if (Array.isArray($scope.leagues)) {
          let previous_league_index = $scope.currentLeagueIndex - 1;
          if (previous_league_index < 0) {
            previous_league_index = $scope.leagues.length - 1;
          }
          $scope.currentLeagueIndex = previous_league_index;
          setCurrentLeague();
        }
      };

      $scope.random = function () {
        return 0.5 - Math.random();
      };*/


      //AHL Freeview
      $scope.showFreeview = currentUser.showFreeview();

      //AHl All-Star Classic
      $scope.showAllStars = currentUser.showAllStars();

      //AHL Promotion
      $scope.showPromotion = currentUser.showPromotion();

      //AHL Black Friday
      $scope.showBlackFriday = currentUser.showBlackFriday();

      //AHL Summer
      $scope.showSummer = currentUser.showSummer();

      //AHL MidSeason
      $scope.showMidSeason = currentUser.showMidSeason();

      //AHL Final Price Drop
      $scope.showFinalPriceDrop = currentUser.showFinalPriceDrop();

      //AHL Playoffs 2023
      $scope.showPlayoffs = currentUser.showPlayoffs();

      init();
    }
  ]);


// WEBPACK FOOTER //
// ./app.v2/components/welcome/welcomeController.js